import { cn } from '@components/shadcn/utils';
import { CropIcons, resolveCropIconKey } from './crops';

interface CropIconProps extends React.SVGProps<SVGSVGElement> {
  crop: string;
}

const CropIcon = ({ crop, width = 24, height = 24, ...props }: CropIconProps) => {
  const key = resolveCropIconKey(crop) ?? 'barley';
  const Crop = CropIcons[key] as React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

  return (
    <Crop
      height={height}
      width={width}
      {...props}
      className={cn('fill-current', props.className)}
    />
  );
};

export default CropIcon;
